export const WEEKDAY_MAP = [
    ['workingMonday', 'Пн', 'Понедельник'],
    ['workingTuesday', 'Вт', 'Вторник'],
    ['workingWednesday', 'Ср', 'Среда'],
    ['workingThursday', 'Чт', 'Четверг'],
    ['workingFriday', 'Пт', 'Пятница'],
    ['workingSaturday', 'Сб', 'Суббота'],
    ['workingSunday', 'Вс', 'Воскресенье'],
];
export const getWorkScheduleWeek = (workSchedule) => WEEKDAY_MAP.map(([key, short, title]) => ({
    key,
    title,
    short,
    status: Boolean(workSchedule?.[key]),
    get workTime() {
        return key === 'workingSaturday' ? workSchedule?.workTimeSaturday : workSchedule?.workTime;
    },
    get lunchHour() {
        return key === 'workingSaturday' ? workSchedule?.lunchHourSaturday : workSchedule?.lunchHour;
    },
    get hasLunch() {
        return /\d+/.test(this.lunchHour ?? '');
    },
}));
//# sourceMappingURL=getWorkScheduleWeek.js.map